module.exports = __webpack_public_path__ + "static/media/MA.a6ec3416.jpg";